import { IFolderWorkflowStepsSnapshot } from './interface/folder-workflow-steps-snapshot.interface';

export class FolderWorkflowStepsSnapshot implements IFolderWorkflowStepsSnapshot {
    _id: any;

    get id(): any {
        return this._id;
    }

    set id(value: any) {
        this._id = value;
    }

    folderId: string;
    workflowStepId: number;
    currentStateId: number;
    currentStateName: string;
    currentStateDate: Date;
    stepStartDate: Date;
    completed: boolean;
    inProgress: boolean;
    stepMaxDuration: number; // en minutes

    public createCopy(): FolderWorkflowStepsSnapshot {
        const instance = new FolderWorkflowStepsSnapshot();
        instance.id = this.id;
        instance.folderId = this.folderId;
        instance.workflowStepId = this.workflowStepId;
        instance.currentStateId = this.currentStateId;
        instance.currentStateName = this.currentStateName;
        instance.currentStateDate = this.currentStateDate;
        instance.stepStartDate = this.stepStartDate;
        instance.completed = this.completed;
        instance.inProgress = this.inProgress;
        instance.stepMaxDuration = this.stepMaxDuration;

        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.folderId = other.folderId;
        this.workflowStepId = other.workflowStepId;
        this.currentStateId = other.currentStateId;
        this.currentStateName = other.currentStateName;
        this.currentStateDate = other.currentStateDate;
        this.stepStartDate = other.stepStartDate;
        this.completed = other.completed;
        this.inProgress = other.inProgress;
        this.stepMaxDuration = other.stepMaxDuration;
    }

    /**
     * Retourne un tableau d'instances de FolderWorkflowStepsSnapshot à partir d'un tableau d'instances de IFolderWorkflowStepsSnapshot.
     * @param other : Tableau d'instances de IFolderWorkflowStepsSnapshot.
     * @returns : Tableau d'instances de FolderWorkflowStepsSnapshot.
     */
    public static fromArray(others: IFolderWorkflowStepsSnapshot[]) {
        if (!!others) {
            let steps: FolderWorkflowStepsSnapshot[] = [];

            others.forEach((x) => {
                const step = FolderWorkflowStepsSnapshot.from(x);
                steps.push(step);
            });

            return steps;
        } else {
            return null;
        }
    }

    /**
     * Retourne une instance de FolderWorkflowStepsSnapshot à partir d'une instance de IFolderWorkflowStepsSnapshot.
     * @param other : Instance de IFolderWorkflowStepsSnapshot.
     * @returns : Instance de FolderWorkflowStepsSnapshot.
     */
    public static from(other: IFolderWorkflowStepsSnapshot) {
        if (!!other) {
            const instance = new FolderWorkflowStepsSnapshot();

            instance.id = other.id;
            instance.folderId = other.folderId;
            instance.workflowStepId = other.workflowStepId;
            instance.currentStateId = other.currentStateId;
            instance.currentStateName = other.currentStateName;
            instance.currentStateDate = other.currentStateDate;
            instance.stepStartDate = other.stepStartDate;
            instance.completed = other.completed;
            instance.inProgress = other.inProgress;
            instance.stepMaxDuration = other.stepMaxDuration;

            return instance;
        } else {
            return null;
        }
    }
}
